import { merge } from '~/_v3/common/domain/imm';

import type { AppContext, AuthActorEvents } from './app.machine';

export const setProfile = ({ context, event }: { context: AppContext; event: Extract<AuthActorEvents, { actorId: 'getUserProfile' }> }) => {
	return merge(context, { userProfile: event.output });
};

export const setRedirectLogoutFranceConnectUri = ({
	context,
	event
}: {
	context: AppContext;
	event: Extract<AuthActorEvents, { actorId: 'logoutFranceConnect' }>;
}) => {
	return merge(context, { franceConnectLogoutRedirectUri: event.output.logoutUrl });
};

export const setVersion = ({ context, event }: { context: AppContext; event: Extract<AuthActorEvents, { actorId: 'getHealth' }> }) => {
	return merge(context, { version: event.output.version });
};
